import React from 'react';

import { FeatureBasedRecommendations } from './components/component/FeatureBasedRecommendations.component';
import { FeatureBasedRecommendationsImporter } from './components/component/FeatureBasedRecommendationsImporter';
import { FBRPlaceholder } from './components/component/FBRPlaceholder/FBRPlaceholder';
import { PIPFeatureBasedRecommendationsImporter } from './composable/PIPFeatureBasedRecommendationsImporter';

const Placeholder = (
  <FBRPlaceholder
    color="#E0E0E0"
    showLoadingAnimation
  />
);
export {
  FeatureBasedRecommendations,
  FeatureBasedRecommendationsImporter,
  Placeholder,
  PIPFeatureBasedRecommendationsImporter
};
